import React from 'react';
import { Box } from '@mui/material';

import BringForward from './BringForward';
import BringToFront from './BringToFront';
import HorizontallyAlign from './HorizontallyAlign';
import HorizontallyDistribute from './HorizontallyDistribute';
import SendBackward from './SendBackward';
import SendToBack from './SendToBack';
import VerticallyAlign from './VerticallyAlign';
import VerticallyDistribute from './VerticallyDistribute';

const buttonBorderSx = { width: '100%' } as const;

export default function PositionAndAlignmentButtons() {
  return (
    <Box sx={{ justifyContent: 'space-around', width: '100%', display: 'flex' }}>
      <Box sx={buttonBorderSx}>
        <BringToFront />
      </Box>
      <Box sx={buttonBorderSx}>
        <BringForward />
      </Box>
      <Box sx={buttonBorderSx}>
        <SendBackward />
      </Box>
      <Box sx={{ width: '100%', borderRight: 'solid 1px', borderColor: 'backContrast.main' }}>
        <SendToBack />
      </Box>
      <Box sx={buttonBorderSx}>
        <HorizontallyAlign />
      </Box>
      <Box sx={buttonBorderSx}>
        <HorizontallyDistribute />
      </Box>
      <Box sx={buttonBorderSx}>
        <VerticallyAlign />
      </Box>
      <Box sx={buttonBorderSx}>
        <VerticallyDistribute />
      </Box>
    </Box>
  );
}
